import React from 'react'
import A from '../App.module.css'
import S from './checkout.module.css'
import icon from '../shared/img/icon-128.png'

function NotFound() {
  return (
    <div className={A.container}>
      <div className={A.centerContainer}>
        <div className={S.container}>
          <div className={S.titleContainer}>
            <img height="40px" src={icon} alt="Script Keeper" />
            <h1>Error</h1>
          </div>
          <h2>Page Not Found</h2>
          <p><a href="https://rxscriptkeeper.com">rxscriptkeeper.com</a></p>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
